import {
  Add,
  ArrowDropDownOutlined,
  Check,
  CheckBox,
  CheckBoxOutlineBlank,
  CheckCircleOutlineOutlined,
  Clear,
  Delete,
  DoNotDisturbAltOutlined,
  Inventory2Outlined,
  MoreHoriz,
  MoreVertOutlined,
  Search,
  TuneOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  createFilterOptions,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import DatagridComponent from "../../../../components/datagridComponent";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";
import api from "../../../../services/api";
import ConfiguracoesFlow from "./configuracoesFlow";
import useStyles from "./styles";
const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

export default function BlocosEasyFlow() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const filter = createFilterOptions();
  const colorChip = [
    "chip.main.pending",
    "chip.main.completed",
    "chip.main.inProgress",
    "chip.main.waitingReview",
    "chip.main.waitingReturn",
    "chip.main.arquive",
  ];

  const { setSnackbar, selectedCliente: clienteInfo } = useOutletContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElStatus, setAnchorElStatus] = useState(null);

  // Grupo econômico: visão consolidada dos blocos de todos os membros
  const isGrupo = !!clienteInfo?.isGrupoEconomico;
  const [ownerCreateId, setOwnerCreateId] = useState("");

  const [loadingChecked, setLoadingChecked] = useState(false);
  const [loadingManyStatus, setLoadingManyStataus] = useState(false);
  const [loadingRemoveManyBlocos, setLoadingRemoveManyBlocos] = useState(false);
  const [openRemoveManyModalGrupo, setOpenRemoveManyModalGrupo] =
    useState(false);

  const [loadingRemoveGrupo, setLoadingRemoveGrupo] = useState(false);
  const [loadingBlocosDisponiveis, setLoadingBlocosDisponiveis] = useState([]);
  const [searchBloco, setSearchBloco] = useState("");
  const [searchBlocoDisponivel, setSearchBlocoDisponivel] = useState("");
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [grupoExist, setGrupoExist] = useState(false);
  const [selectBloco, setSelectBloco] = useState([]);
  const [selectBlocoDisponivel, setSelectBlocoDisponivel] = useState([]);

  const [openDeleteManyBlocos, setOpenDeleteManyBlocos] = useState(false);
  const [openDeleteModalGrupo, setOpenDeleteModalGrupo] = useState(false);
  const [openRemoveModalGrupo, setOpenRemoveModalGrupo] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rows, setRows] = useState([]);
  const [thisRowGrupo, setThisRowGrupo] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [buscarGrupo, setBuscarGrupo] = useState("");

  const [idGrupoDelete, setIdGrupoDelete] = useState("");
  const [loadingHandleGrupo, setLoadingHandleGrupo] = useState(false);

  const [loadingDelete, setLoadingDelete] = useState(false);
  const [grupoId, setGrupoId] = useState("");
  const [blocoId, setBlocoId] = useState("");
  const [anchorElOptionsGrupo, setAnchorElOptionsGrupo] = useState(null);
  const [anchorElGrupos, setAnchorElGrupos] = useState(null);
  const [blocosDisponiveis, setBlocosDisponiveis] = useState([]);
  const [handleGrupo, setHandleGrupo] = useState({
    grupoName: "",
    colorGrupo: "",
  });

  const [gruposRow, setGruposRow] = useState([]);

  // Seção interna do Flow: Blocos (padrão) ou Configurações de visibilidade
  const [flowSection, setFlowSection] = useState("blocos");
  const [loadingRows, setLoadingRows] = useState(false);

  // Confirmação ao trocar de aba com alterações de visibilidade não salvas
  const [configVisibilidadeDirty, setConfigVisibilidadeDirty] =
    useState(false);
  const [confirmacaoTrocaAba, setConfirmacaoTrocaAba] = useState(false);
  const [pendingFlowSection, setPendingFlowSection] = useState(null);
  // Incrementado para forçar remount de ConfiguracoesFlow e descartar alterações
  const [configResetKey, setConfigResetKey] = useState(0);

  const handleChangeFlowSection = (value) => {
    if (
      flowSection === "configuracoes" &&
      configVisibilidadeDirty &&
      value !== flowSection
    ) {
      setPendingFlowSection(value);
      setConfirmacaoTrocaAba(true);
      return;
    }
    setFlowSection(value);
  };

  const handleConfirmarTrocaAba = () => {
    setConfirmacaoTrocaAba(false);
    setConfigVisibilidadeDirty(false);
    setConfigResetKey((prev) => prev + 1);
    if (pendingFlowSection) {
      setFlowSection(pendingFlowSection);
    }
    setPendingFlowSection(null);
  };

  const handleCancelarTrocaAba = () => {
    setConfirmacaoTrocaAba(false);
    setPendingFlowSection(null);
  };

  const openMenuOptionsGrupo = Boolean(anchorElOptionsGrupo);
  const open = Boolean(anchorEl);
  const openMenuStatus = Boolean(anchorElStatus);
  const openMenuGrupos = Boolean(anchorElGrupos);
  const deleteBodyGrupo =
    "Se você prosseguir com a operação, o item será retirado do grupo!";
  const deleteBody =
    "Se você prosseguir com a operação, o item e todas as informações associadas serão excluídas permanentemente!";
  const confirmDelete = "Excluir";
  useEffect(() => {
    findManyBlocos();
    findManyGrupos();
  }, [clienteInfo]);

  //AINDA NAO IMPLEMENTADO:
  //timeDeleteBlocos (funcao para calcular tempo de quando o bloco será deletado)

  const rowsMap = useMemo(() => {
    const map = new Map();
    for (const row of rows) {
      map?.set(row?.id, row);
    }

    return map;
  }, [rows]);

  const rowsMapDisponivel = useMemo(() => {
    const map = new Map();
    for (const row of blocosDisponiveis) {
      map?.set(row?.id, row);
    }

    return map;
  }, [blocosDisponiveis]);

  const filteredRows = Array.isArray(grupos)
    ? grupos?.filter((row, index) => {
        row.numero = index;
        // Em grupos econômicos, só exibe grupos de blocos do mesmo cliente
        // dono do bloco em edição (evita associação cruzada entre membros)
        if (isGrupo && thisRowGrupo?.clienteId) {
          if (row?.clienteId !== thisRowGrupo?.clienteId) return false;
        }
        return row?.grupoName
          ?.toLowerCase()
          ?.includes(buscarGrupo?.toLowerCase());
      })
    : [];

  const filteredBlocos = rows?.filter((row, index) => {
    row.numero = index;
    const gruposFilter = grupos
      ?.filter((grupo) =>
        row?.RlGruposBlocosFlow?.some(
          (rlGrupo) => rlGrupo?.grupoId === grupo?.id,
        ),
      )
      ?.map((grupoRow) => grupoRow?.grupoName);
    const statusBloco =
      row?.status === true ? "Bloco ativado" : "Bloco desativado";
    const statusEasyFlow =
      row?.statusEasyFlow === true
        ? "Localizado"
        : row?.statusEasyFlow === false
          ? "Não localizado"
          : "Em análise";
    return (
      row.blocos?.toLowerCase()?.includes(searchBloco?.toLowerCase()?.trim()) ||
      row.nome?.toLowerCase()?.includes(searchBloco?.toLowerCase()?.trim()) ||
      gruposFilter
        ?.join()
        ?.toLowerCase()
        ?.includes(searchBloco?.toLowerCase()?.trim()) ||
      statusBloco
        ?.toLowerCase()
        ?.includes(searchBloco?.toLowerCase()?.trim()) ||
      statusEasyFlow
        ?.toLowerCase()
        ?.includes(searchBloco?.toLowerCase()?.trim())
    );
  });
  const filteredBlocosDisponiveis = blocosDisponiveis?.filter((row, index) => {
    row.numero = index;

    return (
      row.bloco
        ?.toLowerCase()
        ?.includes(searchBlocoDisponivel?.toLowerCase()?.trim()) ||
      row.nome
        ?.toLowerCase()
        ?.includes(searchBlocoDisponivel?.toLowerCase()?.trim())
    );
  });
  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      flex: 0.8,
    },

    ...(isGrupo
      ? [
          {
            field: "ownerNome",
            headerName: "Cliente",
            flex: 0.8,
            renderCell: (params) => params?.row?.ownerNome || "",
          },
        ]
      : []),

    /*  {
      field: "blocos",
      headerName: "Blocos",
      flex: 0.8,
    },
 */
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const thisRow = params.row;

        return (
          <FormControlLabel
            sx={{
              m: 0,
              height: "100%",
              alignItems: "center",
            }}
            control={
              <Checkbox
                size="small"
                checked={params?.row?.status}
                onClick={() => updateStatusBloco(thisRow)}
                color="success"
                disabled={loadingChecked || loadingManyStatus}
                sx={{
                  p: "4px",
                }}
              />
            }
            label={
              <Typography variant="caption" sx={{ lineHeight: 1 }}>
                Bloco {params?.row?.status ? "ativado" : "desativado"}
              </Typography>
            }
          />
        );
      },
    },

    {
      field: "grupo",
      headerName: "Grupo",
      flex: 0.7,
      sortable: false,
      renderCell: (params) => {
        const idGrupo = params?.row?.RlGruposBlocosFlow?.map(
          (idGrup) => idGrup?.grupoId,
        );

        const grupo = grupos?.filter((g) =>
          idGrupo?.some((id) => g?.id === id),
        );

        const thisRow = params?.row;

        const primeiroGrupo = grupo?.[0];
        const totalGrupos = grupo?.length || 0;
        const gruposRestantes = totalGrupos > 1 ? totalGrupos - 1 : 0;

        return (
          <Button
            size="small"
            onClick={(event) => {
              handleClickOptionsGrupo(event);
              setGruposRow(grupo);
              setThisRowGrupo(thisRow);
            }}
            sx={{
              ...styles.buttonGrupo,
              justifyContent: "flex-start",
            }}
            variant="text"
            endIcon={<ArrowDropDownOutlined sx={{ fontSize: 18 }} />}
          >
            <Box
              sx={{
                ...styles.containerDatagridGrupos,
              }}
            >
              {totalGrupos > 0 ? (
                <>
                  {/* Primeiro grupo */}
                  <Chip
                    size="small"
                    label={
                      <Typography
                        sx={{ fontWeight: "bold" }}
                        variant="caption"
                        noWrap
                      >
                        {primeiroGrupo?.grupoName}
                      </Typography>
                    }
                    sx={{
                      ...styles.chipGrupo,
                      height: 18,
                      maxWidth: "100%",
                      bgcolor: primeiroGrupo?.colorGrupo,
                      flex: 1,
                    }}
                  />

                  {/* Contador +X */}
                  {gruposRestantes > 0 && (
                    <Chip
                      size="small"
                      label={`+${gruposRestantes}`}
                      sx={styles.chipCount}
                    />
                  )}
                </>
              ) : (
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    ...styles.textNoGrupo,
                    fontSize: "0.63rem",
                  }}
                >
                  Adicione ou crie um grupo
                </Typography>
              )}
            </Box>
          </Button>
        );
      },
    },

    {
      field: "createAt",
      headerName: "Adicionado em",
      flex: 0.8,
      width: 90,
      valueGetter: (params) => {
        return (params && dayjs(params).toDate()) || "";
      },
      renderCell: (params) => {
        return (
          params?.row?.createAt &&
          dayjs(params?.row?.createAt).format("DD/MM/YYYY HH:mm")
        );
      },
    },

    /*  {
      field: "checkDeleteDate",
      headerName: "Juniper",
      flex: 0.6,
      type: "dataTime",
      sortable: false,
      valueGetter: (params) => {
        return (params && dayjs(params).toDate()) || "";
      },
      renderCell: (params) => {
        const timeDelete = timeDeleteBlocos(params?.row?.checkDeleteDate);

        return (
          <>
            {params?.row?.checkDeleteDate && (
              <Tooltip
                title={`Bloco não localizado no Juniper. ${timeDelete?.mensege}`}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor:
                        theme.palette.mode === "dark" ? "#777777" : "#424242",
                      width: "190px",
                    },
                  },
                }}
                arrow
              >
                <WarningAmberOutlined color={timeDelete?.iconColor} />
              </Tooltip>
            )}
          </>
        );
      },
    }, */
    {
      field: "actions",
      headerName: "",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        const onDelete = (e) => {
          e.stopPropagation();
          const thisRow = params.row;
          setSelectedRow(thisRow);
          setOpenDeleteModal(true);
        };

        return (
          <Box
            key={params.id}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              height: "100%",
            }}
          >
            <Tooltip title="Excluir">
              <IconButton
                size="small"
                onClick={onDelete}
                sx={{
                  p: "4px",
                }}
              >
                <Delete fontSize="small" color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  const columnsBlocosDisponiveis = [
    {
      field: "nome",
      headerName: "Nome",
      flex: 0.8,
    },

    /*  {
      field: "bloco",
      headerName: "Blocos",
      flex: 0.8,
    }, */
  ];
  const handleClose = () => {
    setAnchorEl(null);
    setGrupoExist(false);
  };
  const handleCloseMenuGrupos = () => {
    setAnchorElGrupos(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseCreateModal = () => {
    setBlocosDisponiveis([]);
    setSelectBlocoDisponivel([]);
    setOpenCreateModal(false);
    setSearchBlocoDisponivel("");
    setOwnerCreateId("");
  };

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
    finManyBlocosDisponiveis();
  };

  const finManyBlocosDisponiveis = async () => {
    try {
      setLoadingBlocosDisponiveis(true);
      const response = await api.get("/interno/findMany/blocosDisponiveis");
      setBlocosDisponiveis(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingBlocosDisponiveis(false);
    }
  };
  const findManyBlocos = async () => {
    try {
      setLoadingRows(true);
      const response = await api.post("/interno/findMany/blocos", {
        clienteId: clienteInfo?.id,
      });
      setRows(response?.data);
      setSnackbar({
        children: "Blocos encontrados com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingRows(false);
    }
  };
  const findManyGrupos = async () => {
    try {
      const response = await api.post("/interno/findManyGrupoBlocosFlow", {
        clienteId: clienteInfo?.id,
      });
      if (response.data) {
        setGrupos(response?.data);
      }
    } catch (erro) {
      console.error(erro);
    } finally {
    }
  };

  const deleteManyBlocos = async (selectBloco) => {
    setLoadingRemoveManyBlocos(true);
    try {
      const response = await api.post("/interno/deleteManyBlocos", {
        blocosId: selectBloco,
      });

      const deleteBlocos = selectBloco?.map((bloco) => bloco?.id);

      const newBlocos = rows?.filter(
        (bloco) => !deleteBlocos?.join()?.includes(bloco?.id),
      );

      setRows(newBlocos);
      setSelectBloco([]);
      setSnackbar({
        children: "Blocos deletados",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível deletar blocos",
        severity: "error",
      });
    } finally {
      setLoadingRemoveManyBlocos(false);
      setOpenDeleteManyBlocos(false);
    }
  };

  const updateStatusManyBlocos = async (status) => {
    setLoadingManyStataus(true);
    try {
      const response = await api.post("/interno/update/statusManyBloco", {
        blocosId: selectBloco,
        status: status,
      });
      Array.isArray(response?.data) &&
        response?.data?.map((blocoResponse) => {
          setRows((blocos) =>
            blocos?.map((bloco) =>
              bloco?.id === blocoResponse?.id
                ? { ...bloco, status: blocoResponse.status }
                : bloco,
            ),
          );
        });
      setSelectBloco([]);

      setSnackbar({
        children: "Status do bloco atualizado",
        severity: "success",
      });
    } catch {
      setSnackbar({
        children: "Erro ao atualizar status do bloco",
        severity: "error",
      });
    } finally {
      handleCloseMenuStatus();
      setLoadingManyStataus(false);
    }
  };

  const createBloco = async () => {
    if (isGrupo && !ownerCreateId) {
      setSnackbar({
        children: "Selecione o cliente dono dos blocos",
        severity: "info",
      });
      return;
    }
    try {
      const response = await api.post("/interno/create/blocos", {
        blocosArray: selectBlocoDisponivel?.map((bloco) => ({
          nome: bloco?.nome,
          blocos: bloco?.bloco,
          // Em grupos econômicos, o bloco é criado no cliente membro escolhido
          clienteId: isGrupo ? ownerCreateId : clienteInfo?.id,
          status: true,
        })),
      });
      setRows((prev) => [...prev, ...response?.data]);
      setSnackbar({
        children: "Bloco criado com sucesso",
        severity: "success",
      });
      handleCloseCreateModal();
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: "Error: Não foi possível criar o bloco",
        severity: "error",
      });
    } finally {
    }
  };

  const deleteBloco = async () => {
    try {
      setLoadingDelete(true);

      const response = await api.post("/interno/delete/blocos", {
        id: selectedRow.id,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível excluir dados",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Dados excluídos com sucesso",
          severity: "success",
        });
        if (response.data) {
          setRows((blocos) =>
            blocos?.filter((bloco) => bloco?.id !== selectedRow?.id),
          );
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível excluir bloco",
        severity: "error",
      });
    } finally {
      setLoadingDelete(false);
      setOpenDeleteModal(false);
    }
  };

  const editarGrupo = async () => {
    if (handleGrupo?.grupoName?.trim()) {
      if (
        grupos?.some(
          (grupo) =>
            grupo.grupoName.trim() === handleGrupo?.grupoName.trim() &&
            grupo?.id !== handleGrupo?.id,
        )
      ) {
        setGrupoExist(true);
      } else {
        setGrupoExist(false);
        try {
          const response = await api.post("/interno/edit/grupoBlocosFlow", {
            grupoId: handleGrupo?.id,
            grupoName: handleGrupo?.grupoName?.trim(),
            colorGrupo: handleGrupo?.colorGrupo,
          });
          const newGrupos = grupos?.map((grupo) =>
            grupo?.id === response?.data?.id ? response?.data : grupo,
          );
          setGrupos(newGrupos);
          setGruposRow((gruposRow) =>
            gruposRow?.map((grupoRow) =>
              grupoRow?.id === response?.data?.id ? response?.data : grupoRow,
            ),
          );

          setSnackbar({
            children: "Grupo editado com sucesso",
            severity: "success",
          });
        } catch (error) {
          console.error(error);
          setSnackbar({
            children: "Erro ao editar grupo",
            severity: "error",
          });
        } finally {
          handleClose();
        }
      }
    }
  };
  const updateStatusBloco = async (bloco) => {
    try {
      setLoadingChecked(true);
      const response = await api.post("/interno/update/statusBloco", {
        id: bloco?.id,
        status: !bloco?.status,
      });

      setRows((prev) =>
        prev?.map((bloco) => {
          if (bloco?.id === response?.data?.id) {
            return response?.data;
          }
          return bloco;
        }),
      );
      setSnackbar({
        children: "Status do bloco atualizado com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível atualizar o status do bloco",
        severity: "error",
      });
    } finally {
      setLoadingChecked(false);
    }
  };

  const deleteGrupo = async () => {
    setLoadingHandleGrupo(true);

    try {
      const response = await api.post("/interno/delete/grupoBlocosFlow", {
        grupoId: idGrupoDelete,
      });
      const newGrupos = grupos?.filter((grupo) => grupo?.id !== idGrupoDelete);
      setGrupos(newGrupos);
      setGruposRow((gruposRow) =>
        gruposRow?.filter((grupoRow) => grupoRow?.id !== idGrupoDelete),
      );
      setIdGrupoDelete("");
      setSnackbar({
        children: "Grupo deletado",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível deletar o grupo",
        severity: "error",
      });
    } finally {
      setLoadingHandleGrupo(false);
      setOpenDeleteModalGrupo(false);
      handleClose();
    }
  };

  const handleClickOptionsGrupo = (event) => {
    setAnchorElOptionsGrupo(event?.currentTarget);
  };
  const handleCloseOptionsGrupo = () => {
    setAnchorElOptionsGrupo(null);
  };

  const criarGrupo = async (grupoName) => {
    let min = Math.ceil(0);
    let max = Math.floor(6);
    let indexColorChip = Math.floor(Math.random() * (max - min)) + min;

    if (grupoName.trim() === "") {
      setSnackbar({
        children: "Necessário informar o nome do grupo",
        severity: "info",
      });
    } else {
      try {
        const response = await api.post("/interno/create/grupoBlocosFlow", {
          // Em grupos econômicos, o grupo de blocos é criado no cliente
          // membro dono do bloco em edição
          clienteId: isGrupo
            ? thisRowGrupo?.clienteId || clienteInfo?.id
            : clienteInfo?.id,
          blocoName: grupoName?.trim(),
          colorGrupo: colorChip[indexColorChip],
        });

        setSnackbar({
          children: "Grupo criado com sucesso",
          severity: "success",
        });
        if (response?.data) {
          setGrupos((grupos) => [...grupos, response?.data]);
        }
      } catch (error) {
        console.error(error);
        setSnackbar({
          children: "Erro ao criar grupo",
          severity: "error",
        });
      } finally {
      }
    }
  };
  const addGrupoBloco = async (blocoId, grupoId) => {
    setLoadingHandleGrupo(true);
    try {
      const response = await api.post("/interno/create/rlGrupoBlocosFlow", {
        blocoId: blocoId,
        grupoId: grupoId?.id,
      });
      setGruposRow((grupoRow) => [...grupoRow, grupoId]);
      setRows((blocos) =>
        blocos?.map((bloco) =>
          bloco?.id === response?.data?.blocoId
            ? {
                ...bloco,
                RlGruposBlocosFlow: [
                  ...bloco?.RlGruposBlocosFlow,
                  response?.data,
                ],
              }
            : bloco,
        ),
      );

      setSelectBloco([]);
      setSelectedRow([]);

      setSnackbar({
        children: "Adicionado blocos ao grupo",
        severity: "success",
      });
      setBuscarGrupo("");
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível atualizar o grupo",
        severity: "error",
      });
      console.error(error);
    } finally {
      setLoadingHandleGrupo(false);
      handleCloseMenuGrupos();
    }
  };

  const deleteBlocosGrupos = async (blocoId, grupoId) => {
    setLoadingHandleGrupo(true);
    setLoadingRemoveGrupo(true);
    try {
      const response = await api.post("/interno/delete/rlGrupoBlocosFlow", {
        blocoId: blocoId,
        grupoId: grupoId?.id,
      });

      setGruposRow((grupoRow) =>
        grupoRow?.filter((grupo) => grupo?.id !== grupoId?.id),
      );

      setRows((blocos) =>
        blocos?.map((bloco) =>
          bloco?.id === blocoId
            ? {
                ...bloco,
                RlGruposBlocosFlow: bloco?.RlGruposBlocosFlow?.filter(
                  (grupo) => grupo?.grupoId !== grupoId?.id,
                ),
              }
            : bloco,
        ),
      );

      setSnackbar({
        children: "Blocos retirados do grupo",
        severity: "success",
      });

      setBuscarGrupo("");
      setSelectBloco([]);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro: Não foi possível retirar blocos do grupo",
        severity: "error",
      });
    } finally {
      setLoadingHandleGrupo(false);
      setOpenRemoveModalGrupo(false);
      setBlocoId("");
      setGrupoId("");
      setLoadingRemoveGrupo(false);
    }
  };

  const addManyBlocosGrupos = async (blocosId, grupoId) => {
    setLoadingHandleGrupo(true);
    try {
      const response = await api.post("/interno/createMany/rlGrupoBlocosFlow", {
        blocosId: blocosId,
        grupoId: grupoId,
      });
      setRows((blocos) =>
        blocos?.map((bloco) => {
          const blocoAtualizado = response?.data?.find(
            (responseBloco) => responseBloco?.blocoId === bloco?.id,
          );

          if (blocoAtualizado) {
            return {
              ...bloco,
              RlGruposBlocosFlow: [
                ...bloco?.RlGruposBlocosFlow,
                blocoAtualizado,
              ],
            };
          }

          return bloco;
        }),
      );
      setSelectBloco([]);
      setSelectedRow([]);
      setSnackbar({
        children: "Adicionado blocos ao grupo",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        children: "Error: Não foi possível atualizar o grupo",
        severity: "error",
      });
    } finally {
      setLoadingHandleGrupo(false);
      handleCloseMenuGrupos();
    }
  };
  const deleteManyBlocosGrupos = async (blocosId) => {
    setLoadingHandleGrupo(true);
    setLoadingRemoveGrupo(true);
    try {
      const response = await api.post("/interno/deleteMany/rlGrupoBlocosFlow", {
        blocosId: blocosId,
      });

      setRows((blocos) =>
        blocos?.map((bloco) => {
          const blocoAtualizado = blocosId?.find(
            (blocoId) => blocoId?.id === bloco?.id,
          );

          if (blocoAtualizado) {
            return {
              ...bloco,
              RlGruposBlocosFlow: [],
            };
          }

          return bloco;
        }),
      );

      setSelectBloco([]);
      setSnackbar({
        children: "Blocos retirados do grupo",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro: Não foi possível retirar blocos do grupo",
        severity: "error",
      });
    } finally {
      setLoadingHandleGrupo(false);
      setOpenRemoveModalGrupo(false);
      setBlocoId("");
      setGrupoId("");
      handleCloseMenuGrupos();
      setOpenRemoveManyModalGrupo(false);
      setLoadingRemoveGrupo(false);
    }
  };
  const handleClickMenuGrupos = (event) => {
    setAnchorElGrupos(event.currentTarget);
  };
  const handleCloseMenuStatus = () => {
    setAnchorElStatus(null);
  };
  const handleClickMenuStatus = (event) => {
    setAnchorElStatus(event.currentTarget);
  };
  return (
    <>
      <Paper
        elevation={theme.palette.mode === "dark" ? 0 : 3}
        sx={styles.paperContainer}
      >
        <Typography sx={styles.title}>Flow</Typography>

        <Tabs
          value={flowSection}
          onChange={(e, value) => handleChangeFlowSection(value)}
          sx={styles.sectionTabs}
        >
          <Tab
            value="blocos"
            label="Blocos"
            icon={<Inventory2Outlined fontSize="small" />}
            iconPosition="start"
            sx={styles.sectionTab}
          />
          <Tab
            value="configuracoes"
            label="Configurações"
            icon={<TuneOutlined fontSize="small" />}
            iconPosition="start"
            sx={styles.sectionTab}
          />
        </Tabs>

        {flowSection === "configuracoes" ? (
          <ConfiguracoesFlow
            key={configResetKey}
            setSnackbar={setSnackbar}
            clienteId={clienteInfo?.id}
            isGrupoEconomico={isGrupo}
            onDirtyChange={setConfigVisibilidadeDirty}
          />
        ) : (
          <Paper elevation={0} sx={styles.paperSupContainer}>
            <Box sx={styles.boxActions}>
              <Box />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Box sx={styles.containerAcoes}>
                    {selectBloco?.length > 0 && (
                      <Box sx={styles.containerAcoesButton}>
                        <Button
                          variant="filled"
                          startIcon={<MoreVertOutlined />}
                          onClick={handleClickMenuStatus}
                        >
                          Status
                        </Button>
                        <Button
                          variant="filled"
                          startIcon={<MoreVertOutlined />}
                          onClick={handleClickMenuGrupos}
                        >
                          Grupos
                        </Button>

                        <Button
                          variant="outlined"
                          startIcon={<Delete />}
                          onClick={() => setOpenDeleteManyBlocos(true)}
                        >
                          Excluir
                        </Button>

                        <Menu
                          anchorEl={anchorElStatus}
                          open={openMenuStatus}
                          onClose={handleCloseMenuStatus}
                        >
                          <MenuItem
                            onClick={() => updateStatusManyBlocos(true)}
                          >
                            <ListItemIcon>
                              <CheckCircleOutlineOutlined />
                            </ListItemIcon>
                            <ListItemText>
                              {" "}
                              Ativar bloco
                              {selectBloco?.length > 1 ? "s" : ""}
                            </ListItemText>
                          </MenuItem>
                          <MenuItem
                            onClick={() => updateStatusManyBlocos(false)}
                          >
                            <ListItemIcon>
                              <DoNotDisturbAltOutlined />
                            </ListItemIcon>
                            <ListItemText>
                              {" "}
                              Desativar bloco
                              {selectBloco?.length > 1 ? "s" : ""}
                            </ListItemText>
                          </MenuItem>
                        </Menu>

                        <Menu
                          anchorEl={anchorElGrupos}
                          open={openMenuGrupos}
                          onClose={handleCloseMenuGrupos}
                        >
                          <Box sx={{ maxHeight: "300px" }}>
                            {grupos?.map((grupo) => (
                              <MenuItem
                                onClick={() =>
                                  addManyBlocosGrupos(selectBloco, grupo?.id)
                                }
                              >
                                <ListItemIcon>
                                  <Add />
                                </ListItemIcon>
                                <ListItemText>
                                  {" "}
                                  Adicionar à {grupo?.grupoName}
                                </ListItemText>
                              </MenuItem>
                            ))}
                            <MenuItem
                              onClick={() => setOpenRemoveManyModalGrupo(true)}
                            >
                              <ListItemIcon>
                                <DoNotDisturbAltOutlined />
                              </ListItemIcon>
                              <Typography sx={{ fontWeight: 500 }}>
                                {" "}
                                Remover de todos os grupos
                              </Typography>
                            </MenuItem>
                          </Box>
                        </Menu>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box sx={{}}>
                  <Button
                    onClick={handleOpenCreateModal}
                    startIcon={<Add />}
                    variant="contained"
                  >
                    Adicionar bloco
                  </Button>
                </Box>
              </Box>
            </Box>
            <Paper elevation={0} sx={styles.paperDatagrid}>
              <Box sx={{ mb: "10px" }}>
                <TextField
                  size="small"
                  variant="outlined"
                  label={"Buscar bloco"}
                  value={searchBloco}
                  sx={{ width: "300px" }}
                  autoComplete="off"
                  onChange={(e) => setSearchBloco(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: searchBloco ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setSearchBloco("")}
                          edge="end"
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                />
              </Box>
              <Box
                sx={{ overflow: "hidden", overflowX: "auto", height: "400px" }}
              >
                <DatagridComponent
                  rows={filteredBlocos}
                  columns={columns}
                  loading={loadingRows}
                  options={{
                    disableColumnSorting: true,
                    checkboxSelection: true,
                    rowSelectionModel: selectBloco.map((b) => b.id),

                    isRowSelectable: (params) => !loadingManyStatus,
                    onRowSelectionModelChange: (ids) => {
                      const selecionados = ids?.map((id) => rowsMap.get(id));
                      setSelectBloco(selecionados);
                    },
                    pageSizeOptions: [15],
                    hideFooterPagination: false,
                    hideFooter: filteredBlocos?.length < 15,
                    initialState: {
                      pagination: {
                        paginationModel: {
                          pageSize: 15,
                        },
                      },
                    },
                  }}
                />
              </Box>
            </Paper>
          </Paper>
        )}
      </Paper>

      <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
        <Box sx={styles.boxCreateModal}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h6">Adicionar blocos</Typography>
            {isGrupo && (
              <TextField
                select
                size="small"
                label="Cliente dono dos blocos"
                value={ownerCreateId}
                onChange={(e) => setOwnerCreateId(e.target.value)}
                sx={{ maxWidth: "300px" }}
                helperText={
                  !ownerCreateId
                    ? "Selecione a qual cliente do grupo os blocos pertencem"
                    : ""
                }
              >
                {(clienteInfo?.membros || []).map((membro) => (
                  <MenuItem key={membro?.id} value={membro?.id}>
                    {membro?.nome || ""}
                  </MenuItem>
                ))}
              </TextField>
            )}
            <Paper
              elevation={0}
              sx={{
                display: "flex",
                height: 350,
                overflow: "hidden",
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.background.modalContrast
                    : theme.palette.colors.black.lighter,
                borderRadius: "16px",
                flexDirection: "column",
                p: 2,
                gap: 1,
              }}
            >
              <TextField
                size="small"
                variant="filled"
                label={"Buscar bloco"}
                value={searchBlocoDisponivel}
                sx={{ maxWidth: "300px" }}
                autoComplete="off"
                onChange={(e) => setSearchBlocoDisponivel(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: searchBlocoDisponivel ? (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setSearchBlocoDisponivel("")}
                        edge="end"
                      >
                        <Clear />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
              />
              <Paper
                elevation={0}
                variant="outlined"
                sx={{
                  display: "flex",
                  height: 350,
                  overflow: "hidden",
                  borderRadius: "16px",
                  flexDirection: "column",
                  p: 1,
                  gap: 1,
                }}
              >
                <DatagridComponent
                  loading={loadingBlocosDisponiveis}
                  rows={filteredBlocosDisponiveis}
                  columns={columnsBlocosDisponiveis}
                  options={{
                    checkboxSelection: true,
                    rowSelectionModel: selectBlocoDisponivel.map((b) => b.id),

                    /*  isRowSelectable: (params) => !loadingManyStatus, */
                    onRowSelectionModelChange: (ids) => {
                      const selecionados = ids?.map((id) =>
                        rowsMapDisponivel.get(id),
                      );
                      setSelectBlocoDisponivel(selecionados);
                    },
                  }}
                />
              </Paper>
            </Paper>

            {/* Ações */}
            <Box sx={styles.boxActionsCreateModal}>
              <Button onClick={handleCloseCreateModal}>Cancelar</Button>
              <Button
                variant="contained"
                onClick={createBloco}
                disabled={
                  !selectBlocoDisponivel?.length || (isGrupo && !ownerCreateId)
                }
              >
                {selectBlocoDisponivel?.length === 0
                  ? "Adicionar"
                  : `${selectBlocoDisponivel?.length > 1 ? `Adicionar ${selectBlocoDisponivel?.length} blocos` : `Adicionar ${selectBlocoDisponivel?.length} bloco`}`}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Menu de edição de grupo */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      >
        <Box>
          <TextField
            value={handleGrupo?.grupoName}
            size="small"
            sx={{ margin: "10px" }}
            onChange={(e) => {
              e.stopPropagation();
              setHandleGrupo((prev) => ({
                ...prev,
                grupoName: e.target.value,
              }));
            }}
            error={grupoExist || !handleGrupo?.grupoName?.trim()}
            helperText={
              (grupoExist && "Grupo já existe") ||
              (!handleGrupo?.grupoName?.trim() && "Nome obrigatório")
            }
          />
        </Box>
        <Box>
          <Divider />
          <Button
            startIcon={<Delete color="error" sx={{ marginLeft: "25px" }} />}
            sx={{
              ...styles.buttonAddGrupo,
              justifyContent: "start",
              padding: "10px 0",
              color: theme.palette.text.main,
            }}
            onClick={() => setOpenDeleteModalGrupo(true)}
          >
            Deletar grupo
          </Button>
          <Divider />
        </Box>
        <Box sx={{ p: 1 }}>
          <Typography sx={styles.textNoGrupo}>Cor</Typography>
        </Box>

        <Box>
          {colorChip?.map((color, index) => (
            <MenuItem
              onClick={() =>
                setHandleGrupo((prev) => ({
                  ...prev,
                  colorGrupo: colorChip[index],
                }))
              }
            >
              <Box
                sx={{
                  ...styles.colorSelectChip,
                  backgroundColor: color,
                }}
              ></Box>
              <Typography>
                {index === 0
                  ? "Vermelho"
                  : index === 1
                    ? "Verde"
                    : index === 2
                      ? "Laranja"
                      : index === 3
                        ? "Azul"
                        : index === 4
                          ? "Roxo"
                          : index === 5
                            ? "Cinza"
                            : "Cinza"}
              </Typography>
              {handleGrupo.colorGrupo === colorChip[index] && (
                <ListItemIcon sx={{ marginLeft: "auto" }}>
                  <Check />
                </ListItemIcon>
              )}
            </MenuItem>
          ))}
        </Box>
        <Box sx={styles.containerHandleButtons}>
          <Button onClick={handleClose} size={"small"} sx={styles.buttonHandle}>
            Cancelar
          </Button>
          <Button
            size={"small"}
            variant="contained"
            sx={styles.buttonHandle}
            onClick={editarGrupo}
          >
            Salvar
          </Button>
        </Box>
      </Menu>

      {/* Menu de opções de grupo */}
      <Menu
        id="basic-menu"
        anchorEl={anchorElOptionsGrupo}
        open={openMenuOptionsGrupo}
        onClose={() => {
          handleCloseOptionsGrupo();
          setBuscarGrupo("");
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        sx={{ width: "450px" }}
      >
        <Autocomplete
          freeSolo
          size="small"
          inputValue={buscarGrupo}
          onInputChange={(event, value) => setBuscarGrupo(value)}
          clearIcon={null}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            const { inputValue } = params;
            setBuscarGrupo(inputValue);
            return [];
          }}
          disableCloseOnSelect
          disabled={loadingRemoveGrupo}
          multiple
          onKeyDown={(event) => {
            event.stopPropagation();
            if (
              event.key === "Enter" &&
              buscarGrupo &&
              (!filteredRows?.some(
                (filter) => filter?.grupoName === buscarGrupo,
              ) ||
                filteredRows?.length === 0)
            ) {
              criarGrupo(buscarGrupo);
            }
          }}
          options={[]}
          value={gruposRow ? gruposRow : []}
          getOptionLabel={(option) => option?.grupoName}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => {
              const { key, onDelete, ...tagProps } = getTagProps({
                index,
              });

              return (
                <Chip
                  sx={{ ...styles.chip, bgcolor: option?.colorGrupo }}
                  key={key}
                  label={option.grupoName}
                  {...tagProps}
                  onDelete={() => {
                    setBlocoId(thisRowGrupo?.id);
                    setGrupoId(option);
                    setOpenRemoveModalGrupo(true);
                  }}
                />
              );
            })
          }
          style={{ width: 280, margin: "0 auto" }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                gruposRow?.length !== 0 ? "" : "Adicione ou crie um grupo"
              }
            />
          )}
        />

        <Box>
          <Divider sx={{ margin: "10px 0" }} />
          <Box sx={{ ml: "10px" }}>
            <Typography sx={styles.textNoGrupo}>
              Selecione ou crie uma opção{" "}
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.containerGrupo}>
          {filteredRows?.length === 0 && buscarGrupo === "" && (
            <Box sx={styles.boxInfo}>
              <Typography sx={styles.textInfo}>
                Cliente não possui grupos
              </Typography>
              <Typography sx={styles.textInfo}>
                Digite para criar um grupo
              </Typography>
            </Box>
          )}

          {filteredRows?.map((grupo) => (
            <Box style={{ width: 300 }}>
              <MenuItem
                onClick={(e) => {
                  if (
                    !gruposRow?.some((grupoRow) => grupoRow?.id === grupo?.id)
                  ) {
                    addGrupoBloco(thisRowGrupo?.id, grupo);
                  } else {
                    deleteBlocosGrupos(thisRowGrupo?.id, grupo);
                  }

                  e.stopPropagation();
                }}
              >
                <Checkbox
                  disabled={loadingHandleGrupo}
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={gruposRow?.some(
                    (grupoRow) => grupoRow?.id === grupo?.id,
                  )}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  style={{ marginRight: 8 }}
                  onChange={(e) => {
                    e.stopPropagation();
                    if (e.target.checked === true) {
                      addGrupoBloco(thisRowGrupo?.id, grupo);
                    } else {
                      deleteBlocosGrupos(thisRowGrupo?.id, grupo);
                    }
                  }}
                />
                <Chip
                  size="small"
                  label={grupo?.grupoName}
                  sx={{
                    ...styles.chipGrupo,
                    bgcolor: grupo?.colorGrupo,
                  }}
                />

                <IconButton
                  onKeyDown={(event) => {
                    event.stopPropagation();
                  }}
                  onClick={(event) => {
                    handleClick(event);
                    setIdGrupoDelete(grupo?.id);
                    setHandleGrupo(grupo);
                    event.preventDefault();
                    event.stopPropagation();
                  }}
                  sx={{ marginLeft: "auto" }}
                >
                  <MoreHoriz fontSize="small" />
                </IconButton>
              </MenuItem>
            </Box>
          ))}
        </Box>
        {buscarGrupo &&
          (!filteredRows?.some((filter) => filter?.grupoName === buscarGrupo) ||
            filteredRows?.length === 0) && (
            <MenuItem
              style={{ width: 300 }}
              onClick={(e) => {
                criarGrupo(buscarGrupo);
                e.stopPropagation();
              }}
            >
              <Typography style={{ ...styles.grupoName, marginLeft: "20px" }}>
                Criar "{buscarGrupo}"
              </Typography>
            </MenuItem>
          )}
      </Menu>
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModal}
        load={loadingDelete}
        setOpenConfirmacao={setOpenDeleteModal}
        execute={() => {
          deleteBloco(selectedRow?.id);
        }}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openRemoveModalGrupo}
        load={loadingRemoveGrupo}
        setOpenConfirmacao={setOpenRemoveModalGrupo}
        execute={() => deleteBlocosGrupos(blocoId, grupoId)}
        severity={"warning"}
        title={"Atenção"}
        contentText={deleteBodyGrupo}
        confirmText={"Prosseguir"}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteModalGrupo}
        load={loadingHandleGrupo}
        setOpenConfirmacao={setOpenDeleteModalGrupo}
        execute={() => deleteGrupo()}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBodyGrupo}
        confirmText={"Excluir"}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openDeleteManyBlocos}
        load={loadingRemoveManyBlocos}
        setOpenConfirmacao={setOpenDeleteManyBlocos}
        execute={() => {
          deleteManyBlocos(selectBloco);
        }}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openRemoveManyModalGrupo}
        load={loadingRemoveGrupo}
        setOpenConfirmacao={setOpenRemoveManyModalGrupo}
        execute={() => {
          deleteManyBlocosGrupos(selectBloco);
        }}
        severity={"error"}
        title={"Atenção"}
        contentText={deleteBody}
        confirmText={confirmDelete}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoTrocaAba}
        setOpenConfirmacao={setConfirmacaoTrocaAba}
        execute={handleConfirmarTrocaAba}
        cancel={handleCancelarTrocaAba}
        title={"Atenção"}
        severity={"warning"}
        confirmText={"Continuar"}
        headerText={"Você está prestes a sair da aba Configurações."}
        contentText={
          "As alterações de visibilidade não salvas serão perdidas, deseja continuar?"
        }
      />
    </>
  );
}
